import { Grid } from '@mui/material';
import { update } from 'lodash';
import { EMPTY_ANIMATION_DATA } from 'src/constants';
import { AnimationTypeKeys, AnimationTypes } from 'src/interfaces';

import { StyledTabPanel } from '../../ProductAnimationAccordion.styled';
import { AnimationStyleSelector } from '../animationStyleSelector/AnimationStyleSelector';
import { FrameRangeSelector } from '../frameRangeSelector/FrameRangeSelector';
import { IMoleculeTabPanelProps } from './MoleculeTabPanel.interface';

export const MoleculeTabPanel = ({
  animation,
  onChange,
}: IMoleculeTabPanelProps) => {
  const handleOnChange = (path: string, value: unknown) => {
    const { delay } = value as any;

    const updatedAnimation = update(
      animation || EMPTY_ANIMATION_DATA,
      path,
      () => (delay === undefined ? null : value),
    );
    onChange(updatedAnimation);
  };

  return (
    <StyledTabPanel value={AnimationTypeKeys.MOLECULE}>
      <Grid container gap={2} direction="column">
        <AnimationStyleSelector />
        <FrameRangeSelector
          id="animation1"
          startFrame={animation?.in?.delay}
          endFrame={animation?.out?.delay}
          onStartFrameChange={(ms) => {
            handleOnChange('in', {
              ...animation?.in,
              delay: ms || 0,
              type: AnimationTypes.FADE,
            });
          }}
          onEndFrameChange={(ms) => {
            handleOnChange('out', {
              ...animation?.out,
              delay: ms,
              type: AnimationTypes.FADE,
            });
          }}
        />
      </Grid>
    </StyledTabPanel>
  );
};
